/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFigma = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4.775 6a3.9 3.9 0 0 1 3.9-3.9h6.156A3.9 3.9 0 0 1 17.323 9a3.9 3.9 0 0 1-2.492 6.9h-.078a3.882 3.882 0 0 1-2.1-.613v2.674c0 2.183-1.79 3.94-3.958 3.94-2.147 0-3.92-1.74-3.92-3.9 0-1.207.548-2.285 1.408-3a3.892 3.892 0 0 1-1.408-3 3.89 3.89 0 0 1 1.408-3 3.892 3.892 0 0 1-1.408-3zm3.9-2.1a2.1 2.1 0 1 0 0 4.2h2.178V3.9zm3.978 0v4.2h2.178a2.1 2.1 0 1 0 0-4.2zM6.575 12c0 1.16.94 2.1 2.1 2.1h2.178V9.9H8.675a2.1 2.1 0 0 0-2.1 2.1zm2.1 3.9a2.1 2.1 0 0 0-2.1 2.1c0 1.152.952 2.1 2.12 2.1 1.189 0 2.158-.965 2.158-2.139v-2.06zm3.978-3.9c0 1.16.94 2.1 2.1 2.1h.078a2.1 2.1 0 1 0 0-4.2h-.078a2.1 2.1 0 0 0-2.1 2.1z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFigma as Figma };
